import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Search, ArrowLeft } from "lucide-react";

/**
 * Selettore mezzi a categorie. Targa e descrizione restano sempre entrambe
 * leggibili: la targa in evidenza a sinistra, la descrizione a capo se serve.
 */
export default function EquipmentTreePicker({ equipment, selected, onToggle }) {
  const [q, setQ] = useState("");
  const [openCat, setOpenCat] = useState(null);

  const cats = Array.from(new Set(equipment.map(e => e.category))).filter(Boolean).sort();
  const term = q.trim().toLowerCase();
  const searching = term.length > 0;
  const matches = (e) => [e.identifier, e.brand, e.model, e.tipo].some(v => (v || "").toLowerCase().includes(term));
  const visible = searching ? equipment.filter(matches)
                           : (openCat ? equipment.filter(e => e.category === openCat) : []);

  return (
    <div className="mt-1">
      <div className="relative mb-2">
        <Search className="absolute left-2 top-1/2 -translate-y-1/2 w-3 h-3 text-slate-400" />
        <Input className="pl-7 h-9 text-sm" value={q} onChange={(e) => setQ(e.target.value)}
               placeholder="Cerca targa, marca o modello..." />
      </div>
      {!searching && openCat && (
        <button type="button" onClick={() => setOpenCat(null)}
                className="text-xs text-orange-600 hover:underline mb-1 inline-flex items-center gap-1">
          <ArrowLeft className="w-3 h-3" /> Tutte le categorie
        </button>
      )}
      <div className="border border-slate-200 rounded max-h-56 overflow-y-auto">
        {!searching && !openCat && (
          cats.length === 0
            ? <div className="p-3 text-xs text-slate-400">Nessuna attrezzatura disponibile</div>
            : cats.map(c => {
                const count = equipment.filter(e => e.category === c).length;
                const sel = equipment.filter(e => e.category === c && selected.includes(e.id)).length;
                return (
                  <button key={c} type="button" onClick={() => setOpenCat(c)}
                          className="w-full text-left p-2 text-sm hover:bg-slate-50 border-b border-slate-100 last:border-0 flex items-center justify-between">
                    <span className="truncate">{c}</span>
                    <span className="text-[10px] text-slate-400 flex-shrink-0">
                      {sel > 0 && <span className="text-orange-600 font-semibold">{sel} sel. · </span>}{count}
                    </span>
                  </button>
                );
              })
        )}
        {(searching || openCat) && (
          visible.length === 0
            ? <div className="p-3 text-xs text-slate-400">Nessun risultato</div>
            : visible.map(e => {
                const descrizione = [e.brand, e.model].filter(Boolean).join(" ");
                return (
                  <label key={e.id} className="flex items-start gap-2 p-2 text-sm hover:bg-slate-50 cursor-pointer border-b border-slate-100 last:border-0">
                    <input type="checkbox" className="mt-0.5 flex-shrink-0"
                           checked={selected.includes(e.id)} onChange={() => onToggle(e.id)} />
                    <span className="min-w-0">
                      <span className="font-mono font-semibold text-[13px] break-all">{e.identifier}</span>
                      {descrizione && <span className="block text-xs text-slate-500 leading-tight">{descrizione}</span>}
                    </span>
                  </label>
                );
              })
        )}
      </div>
    </div>
  );
}
